/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S13_HeadingInputs */

const tr_iade_iptal_s13_heading = /** @type {(inputs: Iade_Iptal_S13_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13. Uyuşmazlık Çözümü`)
};

const en_iade_iptal_s13_heading = /** @type {(inputs: Iade_Iptal_S13_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13. Dispute Resolution`)
};

const de_iade_iptal_s13_heading = /** @type {(inputs: Iade_Iptal_S13_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13. Streitbeilegung`)
};

const ru_iade_iptal_s13_heading = /** @type {(inputs: Iade_Iptal_S13_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13. Разрешение споров`)
};

/**
* | output |
* | --- |
* | "13. Dispute Resolution" |
*
* @param {Iade_Iptal_S13_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s13_heading = /** @type {((inputs?: Iade_Iptal_S13_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S13_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s13_heading(inputs)
	if (locale === "de") return de_iade_iptal_s13_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s13_heading(inputs)
	return tr_iade_iptal_s13_heading(inputs)
});